import { render, staticRenderFns } from "./SwitchPhoneModal.vue?vue&type=template&id=6d058d14&scoped=true"
import script from "./SwitchPhoneModal.vue?vue&type=script&lang=js"
export * from "./SwitchPhoneModal.vue?vue&type=script&lang=js"
import style0 from "./SwitchPhoneModal.vue?vue&type=style&index=0&id=6d058d14&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d058d14",
  null
  
)

export default component.exports